import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import BreadCrumb from "../../components/Breadcrumb";
import FaqItem from "../../components/FaqItem";
import { faqData } from "../../constants/patientFaq";
const PatientFaq = () => {
  const [activeSection, setActiveSection] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState(faqData);

  useEffect(() => {
    let data = faqData.filter(
      (x) =>
        x.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
        x.answer.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredData(data);
  }, [searchTerm]);

  return (
    <div className="faq-page">
      <BreadCrumb pageName="FAQS" />
      <div className="row">
        <div className="col-sm-6">
          <h3 className="page-title">Frequently Asked Questions</h3>
          <p className="page-desc">Questions and answers</p>
        </div>
      </div>
      <div className="container-faq">
        <div className="filter-section">
          <div className="search-bar">
            <FontAwesomeIcon icon={faSearch} />
            <input
              placeholder="Search"
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
        <div className="detail-section">
          {filteredData.map((item, index) => {
            return (
              <FaqItem
                key={index}
                question={item.question}
                answer={item.answer}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default PatientFaq;
